// 1:平日OFF・タイプOFF 2:平日ON・タイプOFF 3:平日OFF・タイプON 4:平日ON・タイプON
export const DAYOFF_TYPEOFF = 1;
export const DAYON_TYPEOFF = 2;
export const DAYOFF_TYPEON = 3;
export const DAYON_TYPEON = 4;
